import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';

interface CoachingCoacheeCohortCoachesSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  <div class={{PAGE_WRAPPER}}>
    <Spinner />
  </div>
</template> satisfies TOC<CoachingCoacheeCohortCoachesSignature>;
